/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Match_Th_RequirementInputs */

const en_deep_match_th_requirement = /** @type {(inputs: Deep_Match_Th_RequirementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requirement`)
};

const de_deep_match_th_requirement = /** @type {(inputs: Deep_Match_Th_RequirementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requirement`)
};

const fr_deep_match_th_requirement = /** @type {(inputs: Deep_Match_Th_RequirementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requirement`)
};

const es_deep_match_th_requirement = /** @type {(inputs: Deep_Match_Th_RequirementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requirement`)
};

const it_deep_match_th_requirement = /** @type {(inputs: Deep_Match_Th_RequirementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requirement`)
};

const nl_deep_match_th_requirement = /** @type {(inputs: Deep_Match_Th_RequirementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requirement`)
};

const pl_deep_match_th_requirement = /** @type {(inputs: Deep_Match_Th_RequirementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requirement`)
};

const fi_deep_match_th_requirement = /** @type {(inputs: Deep_Match_Th_RequirementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requirement`)
};

const da_deep_match_th_requirement = /** @type {(inputs: Deep_Match_Th_RequirementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requirement`)
};

const sv_deep_match_th_requirement = /** @type {(inputs: Deep_Match_Th_RequirementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requirement`)
};

/**
* | output |
* | --- |
* | "Requirement" |
*
* @param {Deep_Match_Th_RequirementInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const deep_match_th_requirement = /** @type {((inputs?: Deep_Match_Th_RequirementInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Match_Th_RequirementInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_deep_match_th_requirement(inputs)
	if (locale === "fr") return fr_deep_match_th_requirement(inputs)
	if (locale === "es") return es_deep_match_th_requirement(inputs)
	if (locale === "it") return it_deep_match_th_requirement(inputs)
	if (locale === "nl") return nl_deep_match_th_requirement(inputs)
	if (locale === "pl") return pl_deep_match_th_requirement(inputs)
	if (locale === "fi") return fi_deep_match_th_requirement(inputs)
	if (locale === "da") return da_deep_match_th_requirement(inputs)
	if (locale === "sv") return sv_deep_match_th_requirement(inputs)
	return en_deep_match_th_requirement(inputs)
});